module.exports = __webpack_public_path__ + "static/media/personal-document.64270ca6.svg";